<template>
    <div class="progress-linear-bar" :class="{ small: small }">
        <div class="label">
            <span v-if="label" class="primary-label">{{ label }}</span>
            <span v-if="endLabel" class="end-label" :class="computedEndLabelColor">{{ endLabel }}</span>
        </div>

        <x-progress-linear
            v-model="value"
            :class="{ 'has-background': backgroundColor }"
            :active="active"
            :background-color="backgroundColor"
            :background-opacity="backgroundOpacity"
            :buffer-value="bufferValue"
            :color="color"
            :height="computedHeight"
            :indeterminate="indeterminate"
            :query="query"
        />

        <div v-if="barLabel" :style="barLabelStyles" :class="barLabelClass" class="bar-label">{{ barLabel }}</div>

        <span v-if="appendedLabel">{{ appendedLabel }}</span>
    </div>
</template>

<script>
    export default {
        name: 'ProgressLinearBar',
        props: {
            value: {
                type: [Number, String]
            },
            label: {
                type: String
            },
            endLabel: {
                type: String
            },
            endLabelColor: {
                type: String
            },
            barLabel: {
                type: String
            },
            barLabelClass: {
                type: String
            },
            appendedLabel: {
                type: String
            },
            active: {
                type: String
            },
            backgroundColor: {
                type: String
            },
            backgroundOpacity: {
                type: [Number, String],
                default: 0.5
            },
            bufferValue: {
                type: [Number, String]
            },
            color: {
                type: String
            },
            height: {
                type: [Number, String]
            },
            indeterminate: {
                type: Boolean
            },
            query: {
                type: Boolean
            },
            small: {
                type: Boolean
            }
        },
        computed: {
            computedHeight() {
                const smallHeight = this.small ? 6 : 12;

                return this.height ? this.height : smallHeight;
            },
            computedEndLabelColor() {
                return this.endLabelColor ? `${this.endLabelColor}--text` : null;
            },
            barLabelStyles() {
                return {
                    height: this.computedHeight + 'px',
                    marginTop: (0 - 4 - this.computedHeight) + 'px',
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .progress-linear-bar {
        font-family: $font-title;

        .label {
            display: flex;
            justify-content: space-between;
        }

        .x-progress-linear {
            margin: 0.25rem 0;
            border-radius: 100px;
        }

        .bar-label {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 0.25rem;
            font-size: rem(11px);
            text-align: center;
        }

        &.small {
            > span {
                font-size: rem(12px);
            }

            .x-progress-linear {
                margin: 0;
            }
        }
    }
</style>

